import * as yup from 'yup';
import callUsLogo from '_assets/assistance/callUs.svg';
import DefaultButton from 'components/DefaultButton';
import mailLogo from '_assets/assistance/mail.svg';
import routes from 'config/routes';
import toast from 'react-hot-toast';
import useStyles from './styles';
import { Box, CircularProgress, Grid, TextField, Typography, Tooltip } from '@material-ui/core';
import { HelpRequestApi } from 'services';
import { toastMessages } from 'config/constants';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { useProvider } from 'contexts/ProviderContext';

const validationSchema = yup
  .object({
    firstName: yup.string().required('Champ obligatoire'),
    lastName: yup.string().required('Champ obligatoire'),
    subject: yup.string().required('Champ obligatoire'),
    message: yup.string().required('Champ obligatoire'),
  })
  .defined();

export default function AssistanceForm() {
  const classes = useStyles();
  const history = useHistory();
  const { provider } = useProvider();

  const { errors, handleChange, handleSubmit, isSubmitting, resetForm, touched, values } = useFormik({
    validationSchema,
    initialValues: {
      firstName: provider?.first_name ?? '',
      lastName: provider?.last_name ?? '',
      subject: '',
      message: '',
    },
    onSubmit: async (values) => {
      const body = {
        first_name: values.firstName,
        last_name: values.lastName,
        subject: values.subject,
        message: values.message,
      };

      try {
        await HelpRequestApi.createHelpRequest(body);
        resetForm({
          subject: '',
          message: '',
        });
        toast.success(toastMessages.success.CREATE_HELP_REQUEST);
      } catch (_) {
        toast.error(toastMessages.error.CREATE_HELP_REQUEST);
      }
    },
  });

  const handleCancel = () => {
    if (isSubmitting) return;
    history.push(routes.parameters.root);
  };

  return (
    <Grid item container xs direction="column" justifyContent="center">
      <Grid className={classes.formContainer} container>
        <form onSubmit={handleSubmit} noValidate autoComplete="off">
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                error={touched.firstName && Boolean(errors.firstName)}
                helperText={touched.firstName && errors.firstName}
                label="Votre prénom"
                name="firstName"
                onChange={handleChange}
                value={values.firstName}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                error={touched.lastName && Boolean(errors.lastName)}
                helperText={touched.lastName && errors.lastName}
                label="Votre nom"
                name="lastName"
                onChange={handleChange}
                value={values.lastName}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                error={touched.subject && Boolean(errors.subject)}
                helperText={touched.subject && errors.subject}
                id="subject"
                label="Objet du message"
                name="subject"
                onChange={handleChange}
                value={values.subject}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                error={touched.message && Boolean(errors.message)}
                helperText={touched.message && errors.message}
                id="message"
                label="Votre message"
                multiline
                name="message"
                onChange={handleChange}
                rows={4}
                type="text"
                value={values.message}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Box className={classes.buttonContainer}>
            <DefaultButton cancel onClick={handleCancel}>
              Annuler
            </DefaultButton>
            <DefaultButton disabled={isSubmitting} color="secondary" variant="contained" type="submit">
              {isSubmitting ? <CircularProgress size={20} /> : 'Valider'}
            </DefaultButton>
          </Box>
        </form>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" style={{ paddingTop: '5vh' }} spacing={10}>
        <Grid item alignItems="center">
          <Tooltip title="envoyer mail à support@maia.partners">
            <a href={'mailto:support@maia.partners'} className={classes.contactButton}>
              <img alt="mailLogo" src={mailLogo} />
              <Typography color="primary">Nous écrire</Typography>
            </a>
          </Tooltip>
        </Grid>

        <Grid item alignItems="center">
          <Tooltip title="appeler +33684375368">
            <a href={'tel:+33684375368'} className={classes.contactButton}>
              <img alt="callUsLogo" src={callUsLogo} />
              <Typography color="primary">Nous appeler</Typography>
            </a>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
}
